import { useState } from "react";

const COUNTRIES = [
  { value: "Australia", de: "Australien", en: "Australia" },
  { value: "Belgium", de: "Belgien", en: "Belgium" },
  { value: "Denmark", de: "Dänemark", en: "Denmark" },
  { value: "Germany", de: "Deutschland", en: "Germany" },
  { value: "England", de: "England", en: "England" },
  { value: "France", de: "Frankreich", en: "France" },
  { value: "Italy", de: "Italien", en: "Italy" },
  { value: "Canada", de: "Kanada", en: "Canada" },
  { value: "Luxembourg", de: "Luxemburg", en: "Luxembourg" },
  { value: "New Zealand", de: "Neuseeland", en: "New Zealand" },
  { value: "Netherlands", de: "Niederlande", en: "Netherlands" },
  { value: "Austria", de: "Österreich", en: "Austria" },
  { value: "Sweden", de: "Schweden", en: "Sweden" },
  { value: "Switzerland", de: "Schweiz", en: "Switzerland" },
  { value: "Spain", de: "Spanien", en: "Spain" },
  { value: "USA", de: "USA", en: "USA" },
];

const OTHER = "__other__";

export default function NationalitySelect({
  id,
  name,
  isDe,
  className,
}: {
  id: string;
  name: string;
  isDe: boolean;
  className?: string;
}) {
  const [value, setValue] = useState("");
  const [otherText, setOtherText] = useState("");

  const finalValue = value === OTHER ? otherText.trim() : value;

  return (
    <>
      <select
        id={id}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className={`${className ?? ""} cursor-pointer`}
      >
        <option value="">{isDe ? "Bitte wählen …" : "Please select …"}</option>
        {COUNTRIES.map((c) => (
          <option key={c.value} value={c.value}>
            {isDe ? c.de : c.en}
          </option>
        ))}
        <option value={OTHER}>{isDe ? "Andere" : "Other"}</option>
      </select>
      {value === OTHER && (
        <input
          type="text"
          value={otherText}
          onChange={(e) => setOtherText(e.target.value)}
          placeholder={isDe ? "Nationalität angeben" : "Please specify"}
          className={`${className ?? ""} mt-2`}
        />
      )}
      <input type="hidden" name={name} value={finalValue} />
    </>
  );
}